// extracted by mini-css-extract-plugin
export default {"searchButton":"FoodSearchButton_searchButton__-rFki","hiddenSearchButton":"FoodSearchButton_hiddenSearchButton__Hq-FN"};